import { render, staticRenderFns } from "./medicion-mortalidad-ver.vue?vue&type=template&id=bc428d4e&scoped=true&"
import script from "./medicion-mortalidad-ver.vue?vue&type=script&lang=js&"
export * from "./medicion-mortalidad-ver.vue?vue&type=script&lang=js&"
import style0 from "./medicion-mortalidad-ver.vue?vue&type=style&index=0&id=bc428d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc428d4e",
  null
  
)

export default component.exports